import React from "react";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import SelectDateInterval from "./SelectDateInterval";
import {encode, decode} from 'html-entities';
import Button from '../widgets/Button';
import TextInput from '../widgets/TextInput';

import './css/editor.css';
import OnlyDatePicker from "./OnlyDatePicker";
export default class SendMailWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            editorState: EditorState.createEmpty(),
            subject: '', 
            eventStartDate: null, 
            eventEndDate: null,
            selectedEndDate: null, 
            selectedStartDate: null,
            errorInStartDate: false, 
            errorInEndDate: false,
        }
    }

    componentDidMount()  {
        
        const startDateString = this.props.eventToSend.startDate[3] + this.props.eventToSend.startDate[4] + "/" + this.props.eventToSend.startDate[0] + this.props.eventToSend.startDate[1] + "/" + this.props.eventToSend.startDate.slice(-4);
        const endDateString = this.props.eventToSend.endDate[3] + this.props.eventToSend.endDate[4] + "/" + this.props.eventToSend.endDate[0] + this.props.eventToSend.endDate[1] + "/" + this.props.eventToSend.endDate.slice(-4);
        
        const startDate = new Date(startDateString);
        const endDate = new Date(endDateString); 

        this.setState({ selectedStartDate: startDate, selectedEndDate: endDate, eventStartDate: startDate, eventEndDate: endDate });
    }

    checkForStartDate(date) {
        console.log(date);
        if(date < this.state.eventStartDate || date > this.state.eventEndDate || date > this.state.selectedEndDate) {
            console.log("ERROR_START");
            this.setState({ errorInStartDate: true });
        } else {
            this.setState({ errorInStartDate: false });
        }
    }

    checkForEndDate(date) {
        console.log(date);
        if(date < this.state.eventStartDate || date > this.state.eventEndDate || date < this.state.selectedStartDate) {
            console.log("ERROR_END");
            this.setState({ errorInEndDate: true });
        } else {
            this.setState({ errorInEndDate: false });
        }
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        console.log('as HTML:', draftToHtml(contentState));
        this.setState({ contentState});
       }

    render (){

        const that = this;
        return ( 

        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container}>
            <div style={mainClass}>
                <div style={closeBtn} onClick={() => {
                    this.props.onClose();
                }}>X</div>
                <div style={title}>Send Mail</div>
                <div style={{marginTop: '20px'}}><b>  Send schedule for this time interval:</b></div>
                <div style={{display: 'flex'}}>
                    <div style={{ flex: 1 }}>
                        <OnlyDatePicker value={this.state.selectedStartDate} name={'Start date'} setDate={(date) => { 
                            this.checkForStartDate(date);
                            this.setState({ selectedStartDate: date });
                        }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <OnlyDatePicker value={this.state.selectedEndDate} name={'End date'} setDate={(date) => { 
                            this.checkForEndDate(date);
                            this.setState({ selectedEndDate: date });
                        }} />
                    </div>
                </div>
                { (this.state.errorInStartDate || this.state.errorInEndDate) && (<div style={{marginStart: '10px', color: 'red'}}>Invalid time interval. Please check dates.</div>) }
                <br/><br/><br/><br/>
                <div>Subject:</div>
                <TextInput name={''} value={this.state.subject} 
                    onChange={(text) => { this.setState({subject: text})}
                } />
                <br/>
                <div>Body:</div>
                <div style={bodyMsg}>
                    <Editor
                            editorState={this.state.editorState}  
                            onContentStateChange={this.onContentStateChange}
                            onEditorStateChange={(editorState) => {
                                this.setState({
                                editorState
                                });
                            }}    
                            toolbarClassName="demo-toolbar-custom"
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor-custom"
                            toolbar={{
                                options: ['inline', 'fontSize', 'fontFamily', 'colorPicker'],       
                                inline: {
                                    options: ['bold', 'italic', 'underline'],
                                    bold: { className: 'bordered-option-classname' },
                                    italic: { className: 'bordered-option-classname' },
                                    underline: { className: 'bordered-option-classname' },
                                },
                            }}
                        />
                </div>
                <br/>

                <Button callback={() => {
                    var subject = '';
                    var body = draftToHtml(this.state.contentState);
                    
                    body = body.replace(/è/g, 'e&#768;');
                    body = body.replace(/à/g, 'a&#768;');
                    body = body.replace(/ò/g, 'o&#768;');
                    body = body.replace(/ù/g, 'u&#768;');
                    body = body.replace(/ì/g, 'i&#768;');

                    body = body.replace(/È/g, 'E&#768;');
                    body = body.replace(/À/g, 'A&#768;');
                    body = body.replace(/Ò/g, 'O&#768;');
                    body = body.replace(/Ù/g, 'U&#768;');
                    body = body.replace(/Ì/g, 'I&#768;');
                    
                    body = body.replace(/á/g, 'a&#769;');
                    body = body.replace(/é/g, 'e&#769;');
                    body = body.replace(/í/g, 'i&#769;');
                    body = body.replace(/ó/g, 'o&#769;');
                    body = body.replace(/ú/g, 'u&#769;');

                    body = body.replace(/Á/g, 'A&#769;');
                    body = body.replace(/É/g, 'E&#769;');
                    body = body.replace(/Í/g, 'I&#769;');
                    body = body.replace(/Ó/g, 'O&#769;');
                    body = body.replace(/Ú/g, 'U&#769;');

                    body = body.replace(/"/g, '&quot;');
                    body = body.replace(/'/g, '&apos;');

                    body = body.replace(/ã/g, 'a&#771;');
                    body = body.replace(/Ã/g, 'A&#771;');
                    body = body.replace(/õ/g, 'o&#771;');
                    body = body.replace(/Õ/g, 'O&#771;');

                    if (this.state.subject == "" || this.state.subject == undefined){
                        alert ('Check the subject');
                        return;
                    }

                    this.props.onSend(this.state.subject, body, this.state.selectedStartDate, this.state.selectedEndDate);
                }} title="SEND"></Button>
            </div>
            </div>
        </div>
        )
    }


}

const mainClass = {
    position: 'fixed',
    top: '10%',
    left: '25%', 
    bottom: '1%',
    minWidth: '50%',
    overflow: 'scroll',
    border: '1px solid black',
    background: '#ffffff',
    padding: '2%'
}

const container = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    background: '#ffffff88',
}

const title = {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    fontWeight: 'bold'
}

const bodyMsg = {
    border: '1px solid black',
    height: '200px', 
}

const inputText = {
    width: '300px',
    padding: '10px'
}

const closeBtn = {
    position: 'absolute',
    right: '15px',
    top: '15px',
    cursor: 'pointer'
}